import { slideDown, slideUp } from "../../utils/slide-functions";

export const setupLists = () => {
	const expandablelistgroups = document.querySelectorAll('.expandable-lists');

	expandablelistgroups.forEach((group) => {
		const expandAll = group.querySelector('.expandable-list-group__expand-all') as HTMLAnchorElement;
		const collapseAll = group.querySelector('.expandable-list-group__collapse-all') as HTMLAnchorElement;
		const toggles = group.querySelectorAll('.expandable-list__item-toggle') as NodeListOf<HTMLAnchorElement>;

		if (expandAll) {
			expandAll.addEventListener('click', function (e) {
				e.preventDefault();

				toggles.forEach((toggle: HTMLAnchorElement) => {
					if (!toggle.classList.contains('active')) {
						toggle.classList.add('active');
						toggle.setAttribute('aria-expanded', 'true');
						const target = toggle.getAttribute('data-target');
						if (target) {
							const targetElement = document.querySelector(target) as HTMLElement | null;
							if (targetElement) {
								slideDown(targetElement);
							}
						}
					}
				});
			});
		}

		if (collapseAll) {
			collapseAll.addEventListener('click', function (e) {
				e.preventDefault();

				toggles.forEach(function (toggle) {

					if (toggle.classList.contains('active')) {
						toggle.classList.remove('active');
						toggle.setAttribute('aria-expanded', 'false');
						const target = toggle.getAttribute('data-target');
						if (target) {
							const targetElement = document.querySelector(target) as HTMLElement | null;
							if (targetElement) {
								slideUp(targetElement);
							}
						}
					}
				});
			});
		}
	});
};